export type ProfileApiErrorField =
  | "role"
  | "team"
  | "phoneNumber"
  | "city"
  | "country"
  | "companyName"
  | "industry"
  | "companySize"
  | "referralSource"
  | "useCases"
  | "platforms"

export type ParsedProfileApiError = {
  fieldErrors: Partial<Record<ProfileApiErrorField, string>>
  formErrors: Array<string>
}

export const GENERIC_PROFILE_SUBMIT_ERROR =
  "We could not save your answers. Please check your connection and try again."

const FIELD_BY_API_KEY: Record<string, ProfileApiErrorField> = {
  jobTitle: "role",
  job_title: "role",
  team: "team",
  phoneNumber: "phoneNumber",
  phone_number: "phoneNumber",
  city: "city",
  country: "country",
  companyName: "companyName",
  company_name: "companyName",
  industry: "industry",
  companySize: "companySize",
  company_size: "companySize",
  referralSource: "referralSource",
  referral_source: "referralSource",
  useCases: "useCases",
  use_cases: "useCases",
  dataPlatforms: "platforms",
  data_platforms: "platforms"
}

const FORM_ERROR_KEYS = new Set(["nonFieldErrors", "non_field_errors"])

const firstMessage = (value: unknown): string | undefined => {
  if (typeof value === "string") return value
  if (!Array.isArray(value)) return undefined

  return value.find((entry): entry is string => typeof entry === "string")
}

const generic = (): ParsedProfileApiError => ({
  fieldErrors: {},
  formErrors: [GENERIC_PROFILE_SUBMIT_ERROR]
})

export const parseProfileApiError = (error: unknown): ParsedProfileApiError => {
  const body = (error as { response?: { data?: unknown } })?.response?.data

  if (!body || typeof body !== "object" || Array.isArray(body)) return generic()

  const fieldErrors: Partial<Record<ProfileApiErrorField, string>> = {}
  const formErrors: Array<string> = []

  Object.entries(body as Record<string, unknown>).forEach(([key, value]) => {
    const message = firstMessage(value)
    if (!message) return

    const field = FIELD_BY_API_KEY[key]

    if (field) {
      fieldErrors[field] = message
      return
    }

    if (FORM_ERROR_KEYS.has(key)) formErrors.push(message)
  })

  const recognised =
    Object.keys(fieldErrors).length > 0 || formErrors.length > 0

  return recognised ? { fieldErrors, formErrors } : generic()
}
